export function getFbc(): string | null {
  if (typeof document === "undefined") return null;

  const match = document.cookie.match(/_fbc=([^;]+)/);
  return match ? match[1] : null;
}
